import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { storage } from '../../utils';
import utils from '../../components/toastify/toastify';

const options = [
  { key: 'store', label: 'فروشگاه محصولات فیزیکی', path: '/store' },
  { key: 'vip', label: 'سرمایه‌گذاری اصولی (VIP)', path: '/vip' },
  { key: 'karshenasi', label: 'کارشناسی خودرو', path: '/karshenasi' },
];

export function ManageSiteSections() {
  const [sections, setSections] = useState({ store: false, vip: false, karshenasi: false });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [loadError, setLoadError] = useState(false);
  useEffect(() => {
    const load = async () => {
      try {
        const token = await storage.load('token');
        const { data } = await Axios.get('/get_main', { headers: { 'x-auth': token } });
        const flags = data.data?.site_sections || {};
        setSections({ store: flags.store === true, vip: flags.vip === true, karshenasi: flags.karshenasi === true });
      } catch (_) {
        setLoadError(true);
        utils.showAlert('دریافت تنظیمات انجام نشد؛ صفحه را دوباره باز کنید.', 'error');
      } finally { setLoading(false); }
    };
    load();
  }, []);
  const save = async () => {
    setSaving(true);
    try {
      const token = await storage.load('token');
      await Axios.post('/edit_site_sections', { site_sections: sections }, { headers: { 'x-auth': token } });
      utils.showAlert('تنظیمات بخش‌های سایت ذخیره شد', 'success');
    } catch (_) { utils.showAlert('ذخیره تنظیمات انجام نشد', 'error'); }
    finally { setSaving(false); }
  };
  return <div className="content-body" dir="rtl"><section className="card"><div className="card-header"><h4>مدیریت بخش‌های سایت</h4></div><div className="card-body">
    <p>بخش غیرفعال از منوهای سایت حذف می‌شود و صفحهٔ آن در دسترس کاربران نخواهد بود. کتاب و سفارش‌های قبلی حذف نمی‌شوند.</p>
    {options.map(({ key, label, path }) => <label key={key} className="d-flex align-items-center mb-2" style={{ gap: 12 }}>
      <input type="checkbox" checked={sections[key]} disabled={loading || saving || loadError} onChange={(event) => setSections({ ...sections, [key]: event.target.checked })} />
      <span>{label} <small dir="ltr">({path})</small> — {sections[key] ? 'فعال' : 'غیرفعال'}</span>
    </label>)}
    <button type="button" className="btn btn-success" disabled={loading || saving || loadError} onClick={save}>{saving ? 'در حال ذخیره…' : 'ذخیره تنظیمات'}</button>
  </div></section></div>;
}
